// extracted by mini-css-extract-plugin
export default {"img_wrap":"OptimizedImage_img_wrap__3j7B+","scale_cover":"OptimizedImage_scale_cover__mbuAj","scale_full":"OptimizedImage_scale_full__ibC4f"};